import {AlertTitle} from '@mui/material';
import {AlertInfo} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import React from 'react';

const {receiptRegistrationAlert} = translations['pt-br'].privateFlow.refund;
export const PaymentReceiptAlert = () => (
	<AlertInfo.Root severity="info">
		<AlertTitle sx={{fontWeight: 400, fontSize: 14, margin: 0}}>
			{receiptRegistrationAlert.description} <strong>{receiptRegistrationAlert.bold}</strong>
			{receiptRegistrationAlert.examples}{' '}
			<strong>{receiptRegistrationAlert.examplesBold}</strong>
		</AlertTitle>
	</AlertInfo.Root>
);
